import React from "react";
import Panel from "./Panel";
import "./SplitPanel.css";

const SplitPanel = ({
  media,
  depth,
  overlay = true,
  overlayClassName,
  overlayStyle,
  left,
  right,
  reverse = false,
  bodyClassName = "about-shell",
  className = "split-panel",
  ...rest
}) => {
  const combinedBodyClassName = [
    "split-panel-grid",
    bodyClassName,
    reverse && "split-panel--reverse",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Panel
      media={media}
      depth={depth}
      overlay={overlay}
      overlayClassName={overlayClassName}
      overlayStyle={overlayStyle}
      className={className}
      bodyClassName={combinedBodyClassName}
      {...rest}
    >
      <div className="split-panel__cell split-panel__cell--primary">{left}</div>
      <div className="split-panel__cell split-panel__cell--secondary">{right}</div>
    </Panel>
  );
};

export default SplitPanel;
